<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.8005 7.83315C13.1871 7.83315 13.5005 8.14655 13.5005 8.53315C13.5005 8.91975 13.1871 9.23315 12.8005 9.23315H4.48983L7.46172 12.205C7.73509 12.4784 7.73509 12.9216 7.46172 13.195C7.18836 13.4684 6.74514 13.4684 6.47177 13.195L2.30511 9.02833C2.03174 8.75497 2.03174 8.31175 2.30511 8.03838L6.47177 3.87172C6.74514 3.59835 7.18836 3.59835 7.46172 3.87172C7.73509 4.14508 7.73509 4.5883 7.46172 4.86167L4.49023 7.83315L12.8005 7.83315Z"
      fill="currentColor"
    />
  </svg>
</template>
